export class DailySalesEnum {
    public static APPROVED = 'Approved';
    public static SUBMITTED = 'Submitted';
    public static DRAFT = 'Draft';
    public static REJECTED = 'Rejected';
}
